export const CARD_WIDTH = 300;
export const CARD_MARGIN = 1;

export const FILTER_ALL = 'All';

export const DRAWER_TYPES = {
  addLocationToTrailer: 'addLocationToTrailer',
  copyPto: 'copyPto',
  createNewCarrierAuth: 'createNewCarrierAuth',
  createNewCustomerAuth: 'createNewCustomerAuth',
  createNewMonthlyNom: 'createNewMonthlyNom',
  createNewPto: 'createNewPto',
  createNewSelfAuth: 'createNewSelfAuth',
  createNewSupplierAuth: 'createNewSupplierAuth',
  createReconsignment: 'createReconsignment',
  editPto: 'editPto',
  editUserPermissions: 'editUserPermissions',
  viewPtoDetails: 'viewPtoDetails',
};

export const RELEASE_NOTES_URL =
  process.env.REACT_APP_RELEASE_NOTES_LINK || 'https://products.magellanlp.com/release-notes';

export const MENU_ITEMS = [
  {
    label: 'Turn On',
    value: 'on',
  },
  {
    label: 'Turn Off',
    value: 'off',
  },
];

export const SELF_AUTH_FILTERS = {
  all: 'All',
  turnedOff: 'Turned Off',
  turnedOn: 'Turned On',
};

export const SUPPLIER_AUTH_FILTERS = {
  any: 'Any',
  daily: 'Daily',
  limitMet: 'Limit Met',
  limited: 'Limited',
  monthly: 'Monthly',
  pendingAcceptance: 'Pending Acceptance',
  self: 'Self',
  semiMonthly: 'Semi-monthly',
  unlimited: 'Unlimited',
  weekly: 'Weekly',
  ...SELF_AUTH_FILTERS,
};

export const AUTHORIZATION_FILTER_OPTIONS = [
  { label: SELF_AUTH_FILTERS.all, value: SELF_AUTH_FILTERS.all },
  { label: SELF_AUTH_FILTERS.turnedOn, value: SELF_AUTH_FILTERS.turnedOn },
  { label: SELF_AUTH_FILTERS.turnedOff, value: SELF_AUTH_FILTERS.turnedOff },
];

export const SUPPLIER_EXCHANGE_FILTER_OPTIONS = [
  { label: SUPPLIER_AUTH_FILTERS.any, value: SUPPLIER_AUTH_FILTERS.any },
  { label: SUPPLIER_AUTH_FILTERS.turnedOn, value: SUPPLIER_AUTH_FILTERS.turnedOn },
  { label: SUPPLIER_AUTH_FILTERS.turnedOff, value: SUPPLIER_AUTH_FILTERS.turnedOff },
  {
    label: SUPPLIER_AUTH_FILTERS.pendingAcceptance,
    value: SUPPLIER_AUTH_FILTERS.pendingAcceptance,
  },
];

export const SUPPLIER_TYPE_FILTER_OPTIONS = [
  { label: SUPPLIER_AUTH_FILTERS.any, value: SUPPLIER_AUTH_FILTERS.any },
  { label: SUPPLIER_AUTH_FILTERS.unlimited, value: SUPPLIER_AUTH_FILTERS.unlimited },
  { label: SUPPLIER_AUTH_FILTERS.monthly, value: SUPPLIER_AUTH_FILTERS.monthly },
  { label: SUPPLIER_AUTH_FILTERS.semiMonthly, value: SUPPLIER_AUTH_FILTERS.semiMonthly },
  { label: SUPPLIER_AUTH_FILTERS.weekly, value: SUPPLIER_AUTH_FILTERS.weekly },
  { label: SUPPLIER_AUTH_FILTERS.daily, value: SUPPLIER_AUTH_FILTERS.daily },
  { label: SUPPLIER_AUTH_FILTERS.self, value: SUPPLIER_AUTH_FILTERS.self },
];

export const MY_AUTH_TYPE_FILTER_OPTIONS = [
  { label: SUPPLIER_AUTH_FILTERS.any, value: SUPPLIER_AUTH_FILTERS.any },
  { label: SUPPLIER_AUTH_FILTERS.unlimited, value: SUPPLIER_AUTH_FILTERS.unlimited },
  { label: SUPPLIER_AUTH_FILTERS.limited, value: SUPPLIER_AUTH_FILTERS.limited },
  { label: SUPPLIER_AUTH_FILTERS.monthly, value: SUPPLIER_AUTH_FILTERS.monthly },
  { label: SUPPLIER_AUTH_FILTERS.semiMonthly, value: SUPPLIER_AUTH_FILTERS.semiMonthly },
  { label: SUPPLIER_AUTH_FILTERS.weekly, value: SUPPLIER_AUTH_FILTERS.weekly },
  { label: SUPPLIER_AUTH_FILTERS.daily, value: SUPPLIER_AUTH_FILTERS.daily },
];

export const SUPPLIER_STATUS_FILTER_OPTIONS = [
  { label: SUPPLIER_AUTH_FILTERS.any, value: SUPPLIER_AUTH_FILTERS.any },
  { label: SUPPLIER_AUTH_FILTERS.turnedOn, value: SUPPLIER_AUTH_FILTERS.turnedOn },
  { label: SUPPLIER_AUTH_FILTERS.turnedOff, value: SUPPLIER_AUTH_FILTERS.turnedOff },
  { label: SUPPLIER_AUTH_FILTERS.limitMet, value: SUPPLIER_AUTH_FILTERS.limitMet },
];

export const EXTENDED_LOADING_FILTER = { ...SELF_AUTH_FILTERS, notAvailable: 'Not Available' };

export const EXTENDED_LOADING_FILTER_OPTIONS = [
  { label: EXTENDED_LOADING_FILTER.all, value: EXTENDED_LOADING_FILTER.all },
  { label: EXTENDED_LOADING_FILTER.turnedOn, value: EXTENDED_LOADING_FILTER.turnedOn },
  { label: EXTENDED_LOADING_FILTER.turnedOff, value: EXTENDED_LOADING_FILTER.turnedOff },
  { label: EXTENDED_LOADING_FILTER.notAvailable, value: EXTENDED_LOADING_FILTER.notAvailable },
];
